import React from 'react';
import "./index.css"
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Navbar from './components/Navbar';
import Home from './components/Home';
import Shop from './components/Shop';
import About from './components/About';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Cart from './components/Cart';
import User from './components/User';
import Footer from './components/Footer';
import AllProductsPage from './components/AllProducts';
import ProductDetail from './components/ProductDetail';
import Checkout from './components/Checkout';
import { Login } from './components/Login';
import { Signup } from './components/Signup';
import Profile from './components/Profile';
import ReturnPolicy from './components/ReturnPolicy';
import PrivacyPolicy from './components/PrivacyPolicy';
import Lookbook from './components/LookBook';
import { MusicProvider } from "./components/MusicContext";
import { ResetPassword } from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import TermsandCondition from './components/TermsandCondition';
import ShippingPolicy from './components/ShippingPolicy';






const App = () => {
  return (
  
    <div className="main-content">
          <MusicProvider>
   <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/shop" element={<Shop />} />
         <Route path="/about-us" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/profile" element={<User/>} />
        <Route path="/cart" element={<Cart />} />  
        <Route path="/all-products" element={<AllProductsPage />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/checkout" element={<Checkout />} /> 
        <Route path= "/login" element={<Login/>} />
        <Route path="/signup" element={<Signup/>} />
       <Route path="/profile/:id" element={<Profile />} />
       <Route path="/return-policy" element={<ReturnPolicy />} />
       <Route path="/privacy-policy" element={ <PrivacyPolicy/>} />
       <Route path="/lookbook" element={<Lookbook/>}/>
       <Route path="/reset-password/:token" element={<ResetPassword />} />
       <Route path="/forgot-password" element={<ForgotPassword />} />
       <Route path="/terms-and-conditions" element={<TermsandCondition/>} />
       <Route path="/shipping-policy" element={<ShippingPolicy/>} />
      
      </Routes>
      <Footer/>
    </Router>
    </MusicProvider>
</div>

  );
};

export default App;
